import { render, staticRenderFns } from "./TodoTasks.vue?vue&type=template&id=01c425f3&scoped=true&"
import script from "./TodoTasks.vue?vue&type=script&lang=js&"
export * from "./TodoTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c425f3",
  null
  
)

export default component.exports